import { render } from "./SankeyChart.vue?vue&type=template&id=7d08346d&scoped=true"
import script from "./SankeyChart.vue?vue&type=script&lang=js"
export * from "./SankeyChart.vue?vue&type=script&lang=js"

import "./SankeyChart.vue?vue&type=style&index=0&id=7d08346d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d08346d"]])

export default __exports__